import './Wizard.a068fa4f75bdacdedb34535e26b16bd3.css';
export default {"wizard":"_wizard_1cxtz_1","stepper":"_stepper_1cxtz_1","footer":"_footer_1cxtz_1"};